import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Premium Volumes', '✅ 5 Bonus Guides FREE'], ['✅ Complete Professional System', '✅ 60-Page Printable Resource Library'], ['✅ Ready-to-Use Session Protocols & Scripts', '✅ Therapeutic Maps & Chakra Diagnostic Tools']];
export const mockupUrl = 'https://cdn.magicpatterns.com/uploads/nvx3RCu7Gfx3DuosA6JpvM/MOCKUP_REIKI_INGLES.png';
export function Hero() {
  return <>
      <section className="w-full bg-mist px-4 py-4 text-navy sm:py-6" data-id="element-109" data-mp="x9ur5oc5w29d">
        <div className="mx-auto max-w-5xl text-center" data-id="element-110" data-mp="x8joxsyd72kd">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-amber" data-id="element-111" data-mp="s9zxjd104ykm">
            Healing Guide
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.05
        }} className="mx-auto mt-3 max-w-3xl font-serif text-4xl leading-[1.02] tracking-tight text-navy sm:text-5xl" data-id="element-112" data-mp="3j9u252lgjune">
            Everything You Need to Practice Reiki With Clarity, Structure &amp; Confidence
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.12
        }} className="mx-auto mt-4 max-w-xl text-sm leading-snug text-slate sm:text-base" data-id="element-113" data-mp="30fybc1yzvc0e">
            Follow a complete step-by-step system with practical techniques, session protocols,
            chakra guides, client tools, and ready-to-use resources — all in one place.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.18
        }} className="mx-auto mt-5 max-w-3xl text-center" data-id="element-114" data-mp="2lmuyu909fogj">
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-amber" data-id="element-115" data-mp="id032nv120n2">
              📦 Everything You Get Instantly
            </p>
            <div className="mt-2 space-y-1 text-xs font-medium text-slate sm:text-sm" data-id="element-116" data-mp="dbastafmpr01">
              {benefitRows.map(row => <p key={row.join('-')} className="flex flex-wrap justify-center gap-x-5 gap-y-1" data-id="element-117" data-mp="161jaz2a60bem">
                  {row.map(benefit => <span key={benefit} data-id="element-118" data-mp="110wpnr8j3u4v">{benefit}</span>)}
                </p>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.24
        }} className="mx-auto mt-5 max-w-3xl" data-id="element-119" data-mp="3ltgo5tkf8wpx">
            <img src={mockupUrl} alt="Therapeutic Reiki Guide complete healing system mockup" fetchPriority="high" decoding="async" className="mx-auto block h-auto w-full max-w-2xl rounded-3xl object-contain shadow-elevated" data-id="element-120" data-mp="1xb5n26cmcdcf" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.3
        }} className="mt-5" data-id="element-121" data-mp="2g02l8lb4zpzx">
            <CTAButton href="#complete-package" pulse size="large" data-id="element-122" data-mp="2p1jxttpc59jv">
              GET INSTANT ACCESS
            </CTAButton>
            <p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-slate sm:text-sm" data-id="element-123" data-mp="2tz20518ukqiw">
              📄 High-Quality PDF <span className="mx-1" data-id="element-124" data-mp="uok99b2z950g">·</span> 🖨️ Printable Resources{' '}
              <span className="mx-1" data-id="element-125" data-mp="zm2mverxw8es">·</span> ⚡ Instant Download <span className="mx-1" data-id="element-126" data-mp="4b47zvkw08ki">·</span> 🔒
              Secure Payment <span className="mx-1" data-id="element-127" data-mp="49jem9ab6vo8">·</span> 🛡️ 7-day guarantee.
            </p>
          </motion.div>
        </div>
      </section>
      <section className="border-y border-amber/40 bg-surface px-4 py-5 text-navy" data-id="element-128" data-mp="e9a765fb70lo">
        <div className="mx-auto max-w-3xl text-center" data-id="element-129" data-mp="e77ipptt1fj2">
          <p className="text-sm font-bold sm:text-base" data-id="element-130" data-mp="9bs6f2bg3ror">
            🚀 Launch offer active — All 5 Bonus Guides FREE with purchase · Price increases when
            the timer hits zero
          </p>
          <div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-amber/20" data-id="element-131" data-mp="3csifxr68kmv7">
            <div className="h-full w-[68%] rounded-full bg-amber" data-id="element-132" data-mp="3rgvi55vx31y5" />
          </div>
          <p className="mt-2 text-xs font-medium text-slate" data-id="element-133" data-mp="3mp3lcdm63zzk">
            68% of launch spots already claimed
          </p>
        </div>
      </section>
    </>;
}